goog.provide('el8.ptdata.medOrderThreads');

goog.require('el8.model.base');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.datecompare');
goog.require('el8.ptdata.medOrders');
goog.require('el8.ptdata.dcMedOrders');
goog.require('el8.ptdata.model.med.thread');

el8.ptdata.medOrderThreads = (function() {

    var that = new el8_EntitySet({
        model: function(spec) { return new el8.ptdata.model.med.thread(spec); },
        observable: true,
        items: [],
        urlFn: function(id) { return el8.service.urls.get('medOrderThreads', [id]); },
        sortFn: function(a, b) {
            if (b.getStartDate().getTime() > a.getStartDate().getTime()) { return 1; }
            if (b.getStartDate().getTime() < a.getStartDate().getTime()) { return -1; }
            return (b.getId() - a.getId());
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            el8.appservice.notifier.notify('Medication thread being deleted...');
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('medOrderThreads', [item.getId()]),
                async: (opts.async !== false), // defaults to true
                success: function(data) {
                    var localFetchOrder = function(orderId) {
                        var orderSet = el8.ptdata.getEntitySet(el8.model.idToModelClass((orderId)));
                        var order = orderSet.getById(orderId, true);
                        return order;
                    };
                    data['remove_visitnote_references'].forEach(function(orderId) {
                        var order = localFetchOrder(orderId);
                        if (order) { el8.appchart.visitNote.main.removeNewOrder(order); }
                    });
                    data['remove_nonvisitnote_references'].forEach(function(orderId) {
                        var order = localFetchOrder(orderId);
                        if (order) { el8.appchart.nonvisitNote.main.removeNewOrder(item); }
                    });

                    data['deleted_order_ids'].forEach(function(orderId) {
                        var orderSet = el8.ptdata.getEntitySet(el8.model.idToModelClass((orderId)));
                        var order = orderSet.getById(orderId, true);
                        if (order) { orderSet.remove(order); }
                    });
                    if (successCb) { successCb(); }
                    el8.appservice.notifier.notify('Medication thread deleted.');
                },
                error: errorCb
            });
        },
        urlLoad: function() { return el8.service.urls.get('medOrderThreads'); }
    });

    /**
     * @param {el8.ptdata.model.med.thread} item
     * @returns {number|null}
     */
    that.getCategoryRank = function(item) {
        if (item.isCanceled()) {
            var sortedCanceledThreads = that.getSortedCanceledThreads();
            for (var i=0; i<sortedCanceledThreads.length; i++) {
                if (sortedCanceledThreads[i].getId() === item.getId()) {
                    return (i + 1);
                }
            }
        } else if (item.isPermanent() && item.isActive()
                && item.getLatestOrder().isPrescription()) {
            var sortedPermRx = that.getSortedPermRx();
            for (var i=0; i<sortedPermRx.length; i++) {
                if (sortedPermRx[i].getId() === item.getId()) {
                    return (i+1);
                }
            }
        } else if (item.isPermanent() && item.isActive()
                && !item.getLatestOrder().isPrescription()) {
            var sortedPermOtc = that.getSortedPermOtc();
            for (var i=0; i<sortedPermOtc.length; i++) {
                if (sortedPermOtc[i].getId() === item.getId()) {
                    return (i+1);
                }
            }
        }
        return null;
    };

    var alphaSortFn = function(a, b) {
        return el8.util.string.cmp(a.getLatestOrder().getDisplayedMedicationName().toLowerCase(), b.getLatestOrder().getDisplayedMedicationName().toLowerCase());
    };

    that.getSortedPermRx = function(byAbc) {
        var all = that.sorted().filter(function(t) {
            return t.isPermanent() && t.isActive() && !t.isCanceled() && t.getLatestOrder().isPrescription();
        });
        return !byAbc ? all : all.sort(alphaSortFn);
    };

    that.getSortedPermOtc = function(byAbc) {
        var all = that.sorted().filter(function(t) {
            return t.isPermanent() && t.isActive() && !t.isCanceled() && !t.getLatestOrder().isPrescription();
        });
        return !byAbc ? all : all.sort(alphaSortFn);
    };

    /**
     * @param {bool} byAbc
     * @returns {array of el8.ptdata.model.med.thread}
     */
    that.getSortedCanceledThreads = function(byAbc) {
        var all = that.sorted().filter(function(t) {
            return t.isCanceled();
        });
        return !byAbc ? all : all.sort(alphaSortFn);
    }

    that.getSortedTemp = function(byAbc) {
        var all = that.sorted().filter(function(t) {
            return !t.isPermanent() && t.isActive();
        });
        return !byAbc ? all : all.sort(alphaSortFn);
    };

    that.getSortedSoyMaps = function(spec) {

        spec = spec || {};
        var exceptId = spec.exceptId || null;
        var includeRxDownload = (spec.includeRxDownload === true); // defaults to false

        var r = {
            'permRx': [],
            'permOtc': [],
            'temp': [],
            'dc': [],
            'canceled': []
        };
        var all = that.sorted();
        for (var i=0; i<all.length; i++) {
            if (all[i].isRxDownload() && !includeRxDownload) {
                continue;
            }
            var soyMap = all[i].asSoyMap();
            if (exceptId && (all[i].getId() === exceptId)) {
                soyMap['isException'] = true;
            }
            if (all[i].isActive()) {
                if (all[i].isCanceled()) {
                    r['canceled'].push(soyMap)
                } else if (all[i].isPermanent()) {
                    if (all[i].getLatestOrder().isPrescription()) {
                        r['permRx'].push(soyMap);
                    } else {
                        r['permOtc'].push(soyMap);
                    }
                } else {
                    r['temp'].push(soyMap);
                }
            } else {
                r['dc'].push(soyMap);
            }
        }
        return r;
    };
    that.sortThreads = function(threads, fn) {
        var r = {
            'permRx': [],
            'permOtc': [],
            'temp': [],
            'dc': [],
            'canceled': []
        };
        threads.sort(function(a, b) {
            if (b.getStartDate().getTime() > a.getStartDate().getTime()) { return 1; }
            if (b.getStartDate().getTime() < a.getStartDate().getTime()) { return -1; }
            return (b.getId() - a.getId());
        });
        for (var i=0; i<threads.length; i++) {
            var m = fn.call(this, threads[i]);
            if (threads[i].isActive()) {
                if (threads[i].isCanceled()) {
                    r['canceled'].push(m)
                } else if (threads[i].isPermanent()) {
                    if (threads[i].getLatestOrder().isPrescription()) {
                        r['permRx'].push(m);
                    } else {
                        r['permOtc'].push(m);
                    }
                } else {
                    r['temp'].push(m);
                }
            } else {
                r['dc'].push(m);
            }
        }
        return r;
    };

    return that;

})();
